export const testimonials = [
  {
    _id: 1,
    testimonial:
      "Assalomaleykum hammaga zor bolibdi ishlarizga rivoj bersin o’zbek dasturchilaridan hech birida open source kurslarni ozi yoq hammasi pullik sotishadi oddiy dasturlash asoslarini o’zini ham pullik qilib sotayotganlari bor men juda xursand bo’ldim bizdek yoshlarni rivojlanishida katta yordam qilyapsiz.",
    author: "Tolib Narzullayev",
    info: "@TNweb_Developer",
  },
  {
    _id: 2,
    testimonial:
      "Ishga kirganimdan ko’rinib turibdiki, kursni menga juda katta yordami tegdi. Bu kursgacha men faqat html css va JavaScript boshlang’ich malumotlarini bilardim. Hozir esa Alhamdulillah junior darajadagi frontend dasturchi bo’ldim. Bu uchun Mohirdevga katta rahmat",
    author: "Islom Alixujaev",
    info: "MERN praktikum o’quvchisi",
    size: "medium",
  },
  {
    _id: 3,
    testimonial:
      "Bir mo’min sifatida ilmingiz bilan foydalik ilm berayapsiz, Alloh dilizdagi o’ylagan niyatlarizdan ham afzaliga yetishtirsin. Sanjar.",
    author: "Sanjar Sanakulov",
    info: "@SanjarSanakulov",
  },
];
